<app-ap-bill-detail
    *ngIf="apBillDetailVisible"
    [visible]="apBillDetailVisible"
    [apBillDetailParam]="apBillDetailParam"
    [isCorporateCirabook]="isCorporateCirabook"
    (onAPBillDetailClose)="onAPBillDetailClose($event)"
></app-ap-bill-detail>

<app-ap-payment-details
    *ngIf="apPaymentDetailVisible"
    [visible]="apPaymentDetailVisible"
    [apPaymentParam]="apPaymentDetailParam"
    (onAPPaymentClose)="onAPPaymentDetailClose($event)"
></app-ap-payment-details>

<app-ap-adjustment
    *ngIf="apAdjustmentDetailVisible"
    [visible]="apAdjustmentDetailVisible"
    [adjustmentDetailParam]="apAdjustmentDetailParam"
    (onAdjustmentDetailClose)="onAPAdjustmentDetailClose($event)"
></app-ap-adjustment>

<app-ar-invoice-details
    *ngIf="arInvoiceDetailVisible"
    [visible]="arInvoiceDetailVisible"
    [invoiceDetailParam]="arInvoiceDetailParam"
    (onSuccess)="onARInvoiceActivitySuccess()"
    (onInvoiceDetailClose)="onARInvoiceDetailClose($event)"
></app-ar-invoice-details>

<app-ar-payment-details
    *ngIf="arPaymentDetailVisible"
    [visible]="arPaymentDetailVisible"
    [arPaymentParam]="arPaymentDetailParam"
    (onARPaymentClose)="onARPaymentDetailClose($event)"
></app-ar-payment-details>

<app-ar-adjustment
    *ngIf="arAdjustmentDetailVisible"
    [visible]="arAdjustmentDetailVisible"
    [adjustmentDetailParam]="arAdjustmentDetailParam"
    (onAdjustmentDetailClose)="onARAdjustmentDetailClose($event)"
></app-ar-adjustment>

<app-cash-receipt-details
    *ngIf="cashReceiptDetailVisible"
    [visible]="cashReceiptDetailVisible"
    [cashReceiptParams]="cashReceiptDetailParam"
    (onCashReceiptClose)="onCashReceiptDetailClose($event)"
></app-cash-receipt-details>

<app-cash-receipts-editor
    *ngIf="cashReceiptEditorVisible"
    [visible]="cashReceiptEditorVisible"
    [title]="cashReceiptEditorParam.title"
    [cashReceipt]="cashReceiptEditorParam.cashReceiptResult"
    [cashReceiptParams]="cashReceiptEditorParam.cashReceiptParam"
    (onCashReceiptClose)="onCashReceiptEditorClose($event)"
></app-cash-receipts-editor>

<app-deposit-details
    *ngIf="depositDetailVisible"
    [visible]="depositDetailVisible"
    [depositParams]="depositDetailParam"
    (onDepositClose)="onDepositDetailClose($event)"
></app-deposit-details>

<app-cb-batch-details
    *ngIf="batchDetailVisible"
    [visible]="batchDetailVisible"
    [batchDetailParam]="batchDetailParam"
    (onBatchDetailClose)="onBatchDetailClose($event)"
></app-cb-batch-details>

<app-journal-entry-detail
    *ngIf="jeDetailVisible"
    [visible]="jeDetailVisible"
    [journalEntryParam]="jeDetailParam"
    (closeJournalEntryDetail)="onJEDetailClose($event)"
></app-journal-entry-detail>

<dx-popup
    *ngIf="workflowDetailVisible"
    width="90%"
    height="95%"
    [title]="workflowDetailPopupTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="workflowDetailVisible"
    (onShown)="onWorkflowDetailShown($event)"
    (onHidden)="onWorkflowDetailClose()"
>
    <div *dxTemplate="let data of 'content'">
        <iframe
            width="100%"
            height="100%"
            class="cc-iframe"
            [title]="workflowDetailPopupTitle"
            [src]="workflowDetailUrl | ccSafeUrl"
            (load)="onWorkflowDetailLoad($event)"
        ></iframe>
    </div>
</dx-popup>

<app-workflow-viewer
    *ngIf="showWorkflowViewer"
    [viewOnly]="showWorkflowViewer"
    [workflowId]="selectedWorkflowId"
    [communityId]="communityId"
    (onClose)="onViewerClose($event)"
></app-workflow-viewer>

<app-gl-batch-summary
    *ngIf="showGLBatchSummary"
    [visible]="showGLBatchSummary"
    [glBatchSummaryParam]="glBatchSummaryParam"
    (closeGLBatchSummary)="onGlBatchSummaryClose($event)"
></app-gl-batch-summary>

<app-cash-receipt-reverse-editor
    *ngIf="cashReceiptReverseEditorVisible"
    [visible]="cashReceiptReverseEditorVisible"
    [cashReceiptParams]="cashReceiptEditorParam.cashReceiptParam"
    (onClose)="onCashReceiptEditorClose($event)"
></app-cash-receipt-reverse-editor>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: 'body' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
    [delay]="0"
></dx-load-panel>
